import { API } from '../../../../API/config'

export const purchaseSubscriptionRequest = (subscriptionModelId) =>
  API.post(`/subscription/purchase`, { subscriptionModelId })
    .then((res) => res.data.data)
    .catch(() => false)
